<div class="card  col-md-3">
  <form class="card-body" #participantForm="ngForm" name="participantForm">
    <h1>Participant: {{firstName}} {{lastName}}</h1>
    <div class="form-group">
      <label for="firstName">First Name</label>
      <input name="firstName" type="text" class="form-control" id="firstName" placeholder="First Name"
             [(ngModel)]="firstName">
    </div>

    <div class="form-group">
      <label for="lastName">Last Name</label>
      <input name="lastName" type="text" class="form-control" id="lastName" placeholder="Last Name"
             [(ngModel)]="lastName">
    </div>

    <div class="form-group">
      <label for="email">Email</label>
      <input name="email" type="email" class="form-control" id="email" placeholder="Email" [(ngModel)]="email">
    </div>

    <div class="form-group">
      <label for="phoneNumber">Phone Number</label>
      <input name="phoneNumber" type="text" class="form-control" id="phoneNumber" placeholder="Phone Number"
             [(ngModel)]="phoneNumber">
    </div>

    <spk-date [(model)]="date" [name]="'testpickerdate'" [minDate]="minDate" (modelChange)="participantForm.form.markAsDirty()"></spk-date>
  </form>

</div>
